export enum CreatorTypeEnum {
    AUTHOR = 1,
    EDITOR = 2,
    ORGA_AS_AUTHOR = 3,
    ORGA_AS_EDITOR = 4,
    GROUP_AS_AUTHOR = 5,
    GROUP_AS_EDITOR = 6
}

export class CreatorType {

    public static editors() {
        return [CreatorTypeEnum.EDITOR, CreatorTypeEnum.ORGA_AS_EDITOR, CreatorTypeEnum.GROUP_AS_EDITOR];
    }

    public static editorsAsPerson() {
        return [CreatorTypeEnum.EDITOR, CreatorTypeEnum.GROUP_AS_EDITOR];
    }

    public static authors() {
        return [CreatorTypeEnum.AUTHOR, CreatorTypeEnum.ORGA_AS_AUTHOR, CreatorTypeEnum.GROUP_AS_AUTHOR];
    }

    public static authorsAsPerson() {
        return [CreatorTypeEnum.AUTHOR, CreatorTypeEnum.GROUP_AS_AUTHOR];
    }

    public static orgas() {
        return [CreatorTypeEnum.ORGA_AS_EDITOR, CreatorTypeEnum.ORGA_AS_AUTHOR];
    }

    public static creators() {
        return [
            CreatorTypeEnum.EDITOR, CreatorTypeEnum.GROUP_AS_EDITOR, CreatorTypeEnum.AUTHOR, CreatorTypeEnum.GROUP_AS_AUTHOR
        ];
    }
}
